'use client';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { clsx } from 'clsx';

interface PaginationWrapperProps {
  max: number;
  active: number;
  className?: string;
}

export function PaginationWrapper({
  max,
  active,
  children,
  className,
}: PropsWithChildren<PaginationWrapperProps>) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (max > 5 && active < max && container) {
      container.scrollTo({
        left: (container.scrollWidth / max) * (active - 1),
        behavior: 'smooth',
      });
      const handleTouchMove = (e: TouchEvent) => {
        e.preventDefault();
      };

      container.addEventListener('touchmove', handleTouchMove, {
        passive: false,
      });

      return () => {
        container.removeEventListener('touchmove', handleTouchMove);
      };
    }
  }, [max, active, containerRef]);
  return (
    <div
      className={clsx(
        'overflow-x-scroll scrollbar-hide scroll-smooth duration-300',
        className
      )}
      ref={containerRef}
    >
      {children}
    </div>
  );
}
export default PaginationWrapper;
